/* tslint:disable */
import { Observable } from 'rxjs';
import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';

import {
  BaseApiClient,
  RequestContext,
  ApiConfigManager,
  HttpRequestState
} from '@sg/api/base-api-lib';
import { BroadcastApiConfig } from '../api-config';

import { BroadcastApi } from '../models';

@Injectable()
export class BroadcastSubscriberApiClient extends BaseApiClient<BroadcastApiConfig> {
  constructor(httpClient: HttpClient, config: ApiConfigManager) {
    super(httpClient, config.broadcastApiConfig);
  }

  subscriberControllerCreateSubscriber(
    body: BroadcastApi.SubscriberCreateDto,

    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<BroadcastApi.Subscriber>;
  subscriberControllerCreateSubscriber(
    body: BroadcastApi.SubscriberCreateDto,

    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<BroadcastApi.Subscriber>>;
  subscriberControllerCreateSubscriber(
    body: BroadcastApi.SubscriberCreateDto,

    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<BroadcastApi.Subscriber>;
  subscriberControllerCreateSubscriber(
    body: BroadcastApi.SubscriberCreateDto,

    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<BroadcastApi.Subscriber>>;
  subscriberControllerCreateSubscriber(
    body: BroadcastApi.SubscriberCreateDto,

    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<BroadcastApi.Subscriber>>;
  subscriberControllerCreateSubscriber(
    body: BroadcastApi.SubscriberCreateDto,

    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<BroadcastApi.Subscriber>>;
  subscriberControllerCreateSubscriber(
    body: BroadcastApi.SubscriberCreateDto,

    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', body]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<BroadcastApi.Subscriber>(
      `${this.basePath}/gateway/admin/broadcast/subscriber`,
      body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  subscriberControllerUpdateSubscriber(
    params: { body: BroadcastApi.SubscriberCreateDto; id: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<BroadcastApi.Subscriber>;
  subscriberControllerUpdateSubscriber(
    params: { body: BroadcastApi.SubscriberCreateDto; id: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<BroadcastApi.Subscriber>>;
  subscriberControllerUpdateSubscriber(
    params: { body: BroadcastApi.SubscriberCreateDto; id: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<BroadcastApi.Subscriber>;
  subscriberControllerUpdateSubscriber(
    params: { body: BroadcastApi.SubscriberCreateDto; id: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<BroadcastApi.Subscriber>>;
  subscriberControllerUpdateSubscriber(
    params: { body: BroadcastApi.SubscriberCreateDto; id: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<BroadcastApi.Subscriber>>;
  subscriberControllerUpdateSubscriber(
    params: { body: BroadcastApi.SubscriberCreateDto; id: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<BroadcastApi.Subscriber>>;
  subscriberControllerUpdateSubscriber(
    params: { body: BroadcastApi.SubscriberCreateDto; id: string },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', params.body], ['id', params.id]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.put<BroadcastApi.Subscriber>(
      `${this.basePath}/gateway/admin/broadcast/subscriber/${this.encodeURI(String(params.id))}`,
      params.body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  subscriberControllerGetSubscriberById(
    id: string,

    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<BroadcastApi.Subscriber>;
  subscriberControllerGetSubscriberById(
    id: string,

    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<BroadcastApi.Subscriber>>;
  subscriberControllerGetSubscriberById(
    id: string,

    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<BroadcastApi.Subscriber>;
  subscriberControllerGetSubscriberById(
    id: string,

    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<BroadcastApi.Subscriber>>;
  subscriberControllerGetSubscriberById(
    id: string,

    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<BroadcastApi.Subscriber>>;
  subscriberControllerGetSubscriberById(
    id: string,

    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<BroadcastApi.Subscriber>>;
  subscriberControllerGetSubscriberById(
    id: string,

    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', id]);

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<BroadcastApi.Subscriber>(
      `${this.basePath}/gateway/admin/broadcast/subscriber/${this.encodeURI(String(id))}`,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  subscriberControllerSearchSubscribers(
    params: {
      body: BroadcastApi.SubscriberSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<BroadcastApi.SubscriberSearchResponse>;
  subscriberControllerSearchSubscribers(
    params: {
      body: BroadcastApi.SubscriberSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<BroadcastApi.SubscriberSearchResponse>>;
  subscriberControllerSearchSubscribers(
    params: {
      body: BroadcastApi.SubscriberSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<BroadcastApi.SubscriberSearchResponse>;
  subscriberControllerSearchSubscribers(
    params: {
      body: BroadcastApi.SubscriberSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<BroadcastApi.SubscriberSearchResponse>>;
  subscriberControllerSearchSubscribers(
    params: {
      body: BroadcastApi.SubscriberSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<BroadcastApi.SubscriberSearchResponse>>;
  subscriberControllerSearchSubscribers(
    params: {
      body: BroadcastApi.SubscriberSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<BroadcastApi.SubscriberSearchResponse>>;
  subscriberControllerSearchSubscribers(
    params: {
      body: BroadcastApi.SubscriberSearchRequestDto;
      pageSize?: number;
      pageNumber?: number;
      order?: 'asc' | 'desc';
      orderBy?: 'createDate' | 'updateDate';
      sortDirection?: 'asc' | 'desc';
    },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', params.body]);

    const consumes = ['application/json'];

    requestContext.queryParams = this.createQueryParams(
      ['', 'pageSize', params.pageSize],
      ['', 'pageNumber', params.pageNumber],
      ['', 'order', params.order],
      ['', 'orderBy', params.orderBy],
      ['', 'sortDirection', params.sortDirection]
    );

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<BroadcastApi.SubscriberSearchResponse>(
      `${this.basePath}/gateway/admin/broadcast/subscriber/search`,
      params.body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  subscriberControllerGetSubscriberScheduling(
    id: string,

    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<BroadcastApi.SubscriberSchedule>;
  subscriberControllerGetSubscriberScheduling(
    id: string,

    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<BroadcastApi.SubscriberSchedule>>;
  subscriberControllerGetSubscriberScheduling(
    id: string,

    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<BroadcastApi.SubscriberSchedule>;
  subscriberControllerGetSubscriberScheduling(
    id: string,

    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<BroadcastApi.SubscriberSchedule>>;
  subscriberControllerGetSubscriberScheduling(
    id: string,

    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<BroadcastApi.SubscriberSchedule>>;
  subscriberControllerGetSubscriberScheduling(
    id: string,

    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<BroadcastApi.SubscriberSchedule>>;
  subscriberControllerGetSubscriberScheduling(
    id: string,

    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', id]);

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<BroadcastApi.SubscriberSchedule>(
      `${this.basePath}/gateway/admin/broadcast/subscriber/${this.encodeURI(String(id))}/schedule`,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  subscriberControllerDeleteSubscriberScheduling(
    id: string,

    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<any>;
  subscriberControllerDeleteSubscriberScheduling(
    id: string,

    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<any>>;
  subscriberControllerDeleteSubscriberScheduling(
    id: string,

    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<any>;
  subscriberControllerDeleteSubscriberScheduling(
    id: string,

    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<any>>;
  subscriberControllerDeleteSubscriberScheduling(
    id: string,

    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<any>>;
  subscriberControllerDeleteSubscriberScheduling(
    id: string,

    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<any>>;
  subscriberControllerDeleteSubscriberScheduling(
    id: string,

    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', id]);

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.delete<any>(
      `${this.basePath}/gateway/admin/broadcast/subscriber/${this.encodeURI(String(id))}/schedule`,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  subscriberControllerCreateOrUpdateSubscriberScheduling(
    params: { body: BroadcastApi.SubscriberSchedule; id: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<BroadcastApi.SubscriberSchedule>;
  subscriberControllerCreateOrUpdateSubscriberScheduling(
    params: { body: BroadcastApi.SubscriberSchedule; id: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<BroadcastApi.SubscriberSchedule>>;
  subscriberControllerCreateOrUpdateSubscriberScheduling(
    params: { body: BroadcastApi.SubscriberSchedule; id: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<BroadcastApi.SubscriberSchedule>;
  subscriberControllerCreateOrUpdateSubscriberScheduling(
    params: { body: BroadcastApi.SubscriberSchedule; id: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<BroadcastApi.SubscriberSchedule>>;
  subscriberControllerCreateOrUpdateSubscriberScheduling(
    params: { body: BroadcastApi.SubscriberSchedule; id: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<BroadcastApi.SubscriberSchedule>>;
  subscriberControllerCreateOrUpdateSubscriberScheduling(
    params: { body: BroadcastApi.SubscriberSchedule; id: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<BroadcastApi.SubscriberSchedule>>;
  subscriberControllerCreateOrUpdateSubscriberScheduling(
    params: { body: BroadcastApi.SubscriberSchedule; id: string },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', params.body], ['id', params.id]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.put<BroadcastApi.SubscriberSchedule>(
      `${this.basePath}/gateway/admin/broadcast/subscriber/${this.encodeURI(String(params.id))}/schedule`,
      params.body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  subscriberControllerExecuteSubscriber(
    params: { body: BroadcastApi.Object; id: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<BroadcastApi.Message>;
  subscriberControllerExecuteSubscriber(
    params: { body: BroadcastApi.Object; id: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<BroadcastApi.Message>>;
  subscriberControllerExecuteSubscriber(
    params: { body: BroadcastApi.Object; id: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<BroadcastApi.Message>;
  subscriberControllerExecuteSubscriber(
    params: { body: BroadcastApi.Object; id: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<BroadcastApi.Message>>;
  subscriberControllerExecuteSubscriber(
    params: { body: BroadcastApi.Object; id: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<BroadcastApi.Message>>;
  subscriberControllerExecuteSubscriber(
    params: { body: BroadcastApi.Object; id: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<BroadcastApi.Message>>;
  subscriberControllerExecuteSubscriber(
    params: { body: BroadcastApi.Object; id: string },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', params.body], ['id', params.id]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<BroadcastApi.Message>(
      `${this.basePath}/gateway/admin/broadcast/subscriber/execute/${this.encodeURI(String(params.id))}`,
      params.body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  subscriberControllerExecuteSubscribersBySearchCriteria(
    body: BroadcastApi.SubscriberSearchRequestDto,

    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<any>;
  subscriberControllerExecuteSubscribersBySearchCriteria(
    body: BroadcastApi.SubscriberSearchRequestDto,

    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<any>>;
  subscriberControllerExecuteSubscribersBySearchCriteria(
    body: BroadcastApi.SubscriberSearchRequestDto,

    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<any>;
  subscriberControllerExecuteSubscribersBySearchCriteria(
    body: BroadcastApi.SubscriberSearchRequestDto,

    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<any>>;
  subscriberControllerExecuteSubscribersBySearchCriteria(
    body: BroadcastApi.SubscriberSearchRequestDto,

    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<any>>;
  subscriberControllerExecuteSubscribersBySearchCriteria(
    body: BroadcastApi.SubscriberSearchRequestDto,

    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<any>>;
  subscriberControllerExecuteSubscribersBySearchCriteria(
    body: BroadcastApi.SubscriberSearchRequestDto,

    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', body]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<any>(
      `${this.basePath}/gateway/admin/broadcast/subscriber/execute-bulk`,
      body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  subscriberControllerSimulateDataObject(
    params: { body: BroadcastApi.Object; id: string; full?: boolean },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<any>;
  subscriberControllerSimulateDataObject(
    params: { body: BroadcastApi.Object; id: string; full?: boolean },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<any>>;
  subscriberControllerSimulateDataObject(
    params: { body: BroadcastApi.Object; id: string; full?: boolean },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<any>;
  subscriberControllerSimulateDataObject(
    params: { body: BroadcastApi.Object; id: string; full?: boolean },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<any>>;
  subscriberControllerSimulateDataObject(
    params: { body: BroadcastApi.Object; id: string; full?: boolean },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<any>>;
  subscriberControllerSimulateDataObject(
    params: { body: BroadcastApi.Object; id: string; full?: boolean },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<any>>;
  subscriberControllerSimulateDataObject(
    params: { body: BroadcastApi.Object; id: string; full?: boolean },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', params.body], ['id', params.id]);

    const consumes = ['application/json'];

    requestContext.queryParams = this.createQueryParams(['', 'full', params.full]);

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<any>(
      `${this.basePath}/gateway/admin/broadcast/subscriber/simulateDataObject/${this.encodeURI(String(params.id))}`,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }
}
